// src/components/ScanUploadBar.jsx — v0.207.4
// ----------------------------------------------------------------------
// Brett: "can these uploads work in the back ground so i can close the screen
// and it still uploads?"
//
// They do now (utils/scanVideoQueue), and the moment they do, this becomes
// necessary rather than decorative: WORK THAT CARRIES ON BEHIND A CLOSED SCREEN
// AND SHOWS NOTHING IS WORSE THAN WORK THAT STOPS. A person who cannot see it
// will close the browser on a half-sent 300 MB clip, or pick the same clips
// again believing nothing happened — which is exactly how v0.207.3's duplicates
// were made.
//
// So while anything is in flight there is one line, above the thumb, wherever
// he is in the app: what is going up, how far, and a way back to the picker.
// It is not dismissible while work is running. A progress indicator somebody
// can hide is a progress indicator that stops being true.
import React, { useEffect, useState } from 'react';
import { theme } from '../theme';
import { Video, AlertTriangle } from 'lucide-react';
import { scanVideoQueue } from '../utils/scanVideoQueue';

export default function ScanUploadBar({ onOpen }) {
  const [queue, setQueue] = useState([]);
  useEffect(() => scanVideoQueue().subscribe(setQueue), []);

  const live = queue.filter(x => x.stage !== 'error');
  const failed = queue.filter(x => x.stage === 'error');
  if (!live.length && !failed.length) return null;

  const current = live.find(x => x.stage === 'uploading') || live[0];
  const pct = current && current.pct != null ? current.pct : null;
  const busy = live.length > 0;

  // v0.207.4 — AND A WARNING BEFORE THE PAGE GOES. Closing the browser really
  // does stop the upload; the clip survives on the device and resumes next
  // time, but he should be told rather than find out.
  useEffect(() => {
    if (!busy) return undefined;
    const warn = (e) => { e.preventDefault(); e.returnValue = ''; return ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [busy]);

  return (
    <button
      onClick={onOpen}
      style={{
        position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 2500,
        display: 'flex', alignItems: 'center', gap: 10, textAlign: 'left',
        padding: '10px 12px', minHeight: 52, cursor: 'pointer',
        background: theme.surface, color: theme.text,
        border: `1px solid ${busy ? theme.border : theme.danger}`,
        borderRadius: 10, boxShadow: '0 6px 18px rgba(15,23,42,0.18)',
      }}
    >
      <span style={{ color: busy ? theme.brand : theme.danger, flexShrink: 0 }}>
        {busy ? <Video size={18} /> : <AlertTriangle size={18} />}
      </span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 13, fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {busy
            ? `Uploading ${current ? current.name : 'video'}${live.length > 1 ? ` (+${live.length - 1} more)` : ''}`
            : `${failed.length} video${failed.length === 1 ? '' : 's'} did not upload`}
        </span>
        <span style={{ display: 'block', fontSize: 11, color: theme.textLight }}>
          {busy
            ? (pct != null ? `${pct}% — keep the app open` : 'Starting…')
            : 'Tap to try again — the clips are still here'}
        </span>
        {busy && (
          <span style={{ display: 'block', height: 3, background: theme.bg, borderRadius: 2, marginTop: 5, overflow: 'hidden' }}>
            <span style={{ display: 'block', height: '100%', width: `${pct || 0}%`, background: theme.brand, transition: 'width .2s' }} />
          </span>
        )}
      </span>
    </button>
  );
}
